import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchGames(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/gstack/games/', { params: queryParams })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchGame(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/gstack/games/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addGame(ctx, gameData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/gstack/games/', gameData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editGame(ctx, gameData) {
      const { id } = gameData
      return new Promise((resolve, reject) => {
        axios
          .patch(`/gstack/games/${id}/`, gameData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
